import axios from 'axios'
import { BUSCAR_IMPOSTOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarImpostos () {
  const url = `${URL}/imposto/todos`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_IMPOSTOS,
        payload: response

      })
  );
}
